export default __webpack_public_path__ + "static/media/Citadele.f8d76de0.svg";